import mutations from './codeStoreExtended.mutations'
import actions from './codeStoreExtended.actions'
import getters from './codeStoreExtended.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
